import { http, HttpResponse } from 'msw';

import { MockServiceWorker } from '../mockServiceWorker';
import { getNextState, getNextStateCoApplicant } from './patchApplicationHandlers';

export const saveKnowYourCustomerAnswersHandlers = [
    http.post('*/api/cl_loanapp_proxy_service/v1/:countryCode/know_your_customer/:arn/save_survey_answers', async () => {
        // Simulate the next step in the flow
        const session = MockServiceWorker.getMockedSession();

        if (MockServiceWorker.isMainApplicant()) {
            session.state = getNextState('KYC_MAIN_APPLICANT');
        } else {
            session.state = getNextStateCoApplicant('KYC_CO_APPLICANT');
        }
        MockServiceWorker.setMockedSession(session);

        return HttpResponse.json([]);
    }),
];
